export default function LeadArea() {
    const addEmbed = (id) => {
        const modalContainer = document.querySelector(`#${id}`);
        const videoID = modalContainer.getAttribute("data-youtubeid");
        const url = `https://player.cvm3.se/${videoID}?fetch=true`;
        $(modalContainer.querySelector('.lead-area__modal__frame'))
            .append(`
            <iframe
                title="Video"
                id='modal_${id}'
                width='560'
                height='315'
                src='${url}'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowfullscreen
            >
            </iframe>
        `);
    }

    const openVideoToggleButtons = document.querySelectorAll('.js-lead-area--open-modal');
    openVideoToggleButtons.forEach((btn) => {
        const container = btn.closest('.lead-area');
        const modalContainer = container.querySelector('.lead-area__modal');
        const popup = new Foundation.Reveal($(modalContainer));

        btn.addEventListener("click", () => {
            addEmbed(modalContainer.id);
            popup.open();
        });
    });

    document.querySelectorAll('.reveal-overlay').forEach((modal) => {
        modal.addEventListener('click', () => {
            modal.querySelector('iframe').remove();
        });
    });
}
